<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import TTRCard from '@/Components/TTRCard.vue';
</script>

<script>
export default {
    mounted(){
        document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-11.jpg') + '")';
        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';
    }
}
</script>

<template>
    <AppLayout title="Tenant's Handbook Inspire Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item" aria-current="page">Rent</li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">Tenant's Handbook</h2>
                <div class="row">
                    <div class="col-lg-6">
                        <!-- <p class="text-white page-header-desc">Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Quisque velit nisi, pretium ut lacinia in, elementum id enim.</p> -->
                    </div>
                </div>
            </div>
        </template>

        <section class="neighbourhood-diary">
            <div class="container">
                <div class="transportation-wrap mt-0">
                    <div class="row">
                        <div class="col-lg-6">
                            <figure class="mb-0">
                                <img :src="asset('/images/handbook/terminology.jpg')" alt="terminology">
                            </figure>
                        </div>
                        <div class="col-lg-6">
                            <div class="transportation-content mt-5">
                                <div class="headings">
                                    <h2>
                                        Terminology
                                    </h2>
                                    <p></p>
                                    <ul>
                                        <p><b>EJARI: </b>It is an online registration tool introduced by the RERA. Each individual tenancy contract has to be registered with EJARI.</p>
                                        <p><b>Tenancy Contract: </b>It is readily available on EJARI’s website with basic terms. You can fill in the landlord’s and tenant’s details along with any additional terms you want to add.</p>
                                        <p><b>RERA: </b>The Real Estate Regulation Authority is the regulating arm of the DLD.</p>
                                        <p><b>DEWA: </b>Dubai Electricity and Water Authority is responsible for the supply of electricity and water in Dubai. The tenant needs to register their EJARI with DEWA to activate the supply.</p>
                                        <p><b>RDC: </b>Rental Dispute Centre is a branch of DLD that handles all the rental disputes in Dubai.</p>
                                        <p><b>No. of cheques: </b>This denotes the number of instalments the tenant is allowed for paying the annual rent.</p>
                                        <p><b>Security Deposit: </b>An amount collected by the landlord as a security against any damage done to the property by the tenant. The industry standard is 5% and 10% of annual rent for unfurnished and furnished properties respectively.</p>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="target pt-4">
            <div class="container">
                <div class="row mt-5">
                    <div class="col-12">
                        <div class="headings styled-list text-white m-w-992 mx-auto">
                            <h2 class="">Tenancy Laws</h2>
                            <p class="sub-title">Registration &amp; Increment</p>
                            <ol>
                                <li><p>Only work with RERA registered brokers. Ask your broker for his/her broker ID. You can verify the same on Dubai Brokers App.</p></li>

                                <li><p>It is compulsory to register Tenancy Contract with EJARI. EJARI certificate will be acceptable at every government agency as a proof of address. The certificate is also needed in case of any dispute.</p></li>

                                <li>
                                    <p>The landlord cannot increase the rent randomly. An increment in rent can only be done in accordance with Rent Index set by RERA. The rental index can be accessed on: <a target="_blank" href="https://dubailand.gov.ae/English/Pages/rental-increase-calculator.aspx" class="text-decoration-none">Click Here.</a></p>
                                </li>
                                <li>
                                    <p>The rent can only be increased according to the following slabs based on the difference between the rent paid and the rent index:</p>
                                    <ul>
                                        <li class="text-white"><p>No increment in rent can be made if the rent is paid up to 10% less than the index.</p></li>
                                        <li class="text-white"><p>In case the rent paid is 11-20% less, the landlord can increase up to 5%</p></li>
                                        <li class="text-white"><p>If it falls short by 21-30%, a 10% hike is allowed</p></li>
                                        <li class="text-white"><p>15% increase is allowed in case the difference is between 31 to 40%</p></li>
                                        <li class="text-white"><p>If the difference is more than 40% the rent can be increased up to 20%</p></li>
                                    </ul>
                                </li>
                                <li><p>The landlord has to give a 90-day notice in case they want to increase the rent.</p></li>
                            </ol>
                            <p class="sub-title">Eviction</p>
                            <p>Renewal of tenancy contract is given to every tenant by law in Dubai. However…</p>
                            <p>In case of a default by the tenant like non payment of rent, subletting without consent, illegal or immoral use of property, etc. the landlord can evict the tenant by giving a 30-day notice.</p>
                            <p>The landlord can request eviction with a 12-month notice for the following reasons:</p>
                            <ul>
                                <li class="text-white"><p>If the landlord wants to sell the property.</p></li>
                                <li class="text-white"><p>If the landlord or their immediate kin wants to move.</p></li>
                            </ul>
                            <p>In this case, the landlord can’t lease the property for 2 years.</p>
                            <p>All of the notices should be served by Notary Public or Registered Post.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="current-assets property-listing-details">
            <div class="container-fluid px-lg-0">
                <div class="row align-items-center px-lg-0 mx-lg-0">
                     <div class="col-lg-10">
                        <div class="current-assets-content">
                            <div class="mb-4 m-w-992 mx-auto">
                                <div class="headings pb-2">
                                    <h2>Steps to Renting</h2>
                                </div>
                                <div class="row mt-5 ms-xl-4">
                                    <div class="col-12">
                                        <p class="sub-title">Viewing Stage:</p>
                                        <ol>
                                            <li><p>Find a registered broker.</p></li>
                                            <li><p>Meet the broker and list all your requirements such as the number of bedrooms, floors, preferable neighbourhoods, etc.</p></li>
                                            <li><p>Mention your budget very specifically, because an open budget will waste a lot of time.</p></li>
                                            <li><p>View the properties offered by the broker.</p></li>
                                            <li><p>If you’re not satisfied with the properties, verify the broker’s understanding of your requirements.</p></li>
                                            <li><p>If you like the property, make an offer.</p></li>
                                        </ol>

                                        <p class="sub-title">Registration Stage:</p>
                                        <ol>
                                            <li><p>If the landlord accepts your offer, book the property by issuing a cheque for security deposit (industry norm is 5%)</p></li>
                                            <li><p>The broker will now get a tenancy contract for you and landlord to sign. Read the terms mentioned in the tenancy contract carefully before signing. You can even mention additional terms you want to include.</p></li>
                                            <li><p>Once you clear all the dues like part or whole of annual rent as agreed with the landlord, the tenancy contract will be registered with EJARI by the broker or landlord. EJARI charges are Dh215 for villas and apartments as well. This is payable by you.</p></li>
                                        </ol>

                                        <p class="sub-title">Moving-in Stage:</p>
                                        <ol>
                                            <li><p>Before moving in, you will have to activate DEWA services by submitting the EJARI certificate. DEWA will charge a security deposit of Dh2,000 for apartments and Dh4,000 for villas. Other than this, an admin fee of Dh130 will be charged in both apartments and villas.</p></li>
                                            <li><p>24 hours after paying the above-mentioned charges, your DEWA services will be activated.</p></li>
                                            <li><p>The next step is to get any permit required from the developer or the management company. This can take up to 5 working days.</p></li>
                                            <li><p>After acquiring all the permits, you can move in the property.</p></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </AppLayout>
</template>

<style scoped>
.page-header-desc{
    position: relative;
    z-index: 3;
}

.nav-pills{
    border-bottom: 1px solid #ccc;
}

.nav-pills .nav-link{
    border-radius: 0px;
    color: var(--bg-dark);
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link{
    background-color: var(--secondary-color);
    color: white;
}

section.current-assets::before{
    height: 98%;
    width: 90%;
}

.tab-pane h5{
    color: var(--bg-dark);
    font-weight: bold;
    margin-top: 2rem;
}

.target a{
    color: var(--secondary-color);
}

.sub-title{
    font-weight: bold;
    color: var(--secondary-color);
}

@media screen and (min-width: 992px) {
    .mt-lg-10{
        margin-top: 6rem !important;
    }
    .mt-lg-n-2{
        margin-top: -0.5rem !important;
    }
}
</style>